import React from 'react'

import { Button, DatePicker, Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const WeekPicker = DatePicker.WeekPicker

const TOOLTIP_TEXT_CHEVRON_LEFT = 'Go back one week'
const TOOLTIP_TEXT_CHEVRON_RIGHT = 'Advance one week'
const DATE_PICKER_STYLE = { width: '125px' }
const NAVIGATION_PERIOD = 'isoWeek'

const WeekNavigator = ({ loading, date, onDateChange, dateFormat, navigationPeriod = NAVIGATION_PERIOD }) => {
  const t = useSelector(selectTranslate)

  const handleChevronClick = navigationQuantity => {
    handleChange(date.clone().add(navigationQuantity, navigationPeriod))
  }

  const handleChange = newDate => {
    onDateChange(newDate.startOf(navigationPeriod).hours(0).minutes(0).seconds(0))
  }

  return (
    <div className='flex-row'>
      <Tooltip placement='top' title={t(TOOLTIP_TEXT_CHEVRON_LEFT)}>
        <Button
          onClick={() => handleChevronClick(-1)}
          disabled={loading}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </Button>
      </Tooltip>
      <div className='h-spacing' />
      <WeekPicker
        allowClear={false}
        onChange={handleChange}
        format={dateFormat}
        value={date}
        style={DATE_PICKER_STYLE}
        disabled={loading}
      />
      <div className='h-spacing' />
      <Tooltip placement='top' title={t(TOOLTIP_TEXT_CHEVRON_RIGHT)}>
        <Button
          onClick={() => handleChevronClick(1)}
          disabled={loading}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </Button>
      </Tooltip>
    </div>
  )
}

export default WeekNavigator
